import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  RadioButtonGroupInput,
  DateInput,
  ImageInput,
  SelectInput,
  ImageField,
  required
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const rawNameRegex = /[ `!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/

const useStyles = makeStyles({
  inline: {
    display: 'inline-block',
    marginLeft: '1em',
    '&.first-child': {
      marginLeft: 0,
    },
  },
});

const BannerCreate = (props) => {
  const [list, setList] = React.useState([]);
  const [translations, setTranslations] = React.useState([]);
  const [type, setType] = React.useState('VIDEO');
  const classes = useStyles();
  const priority = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10' },
    { id: 11, name: '11' },
    { id: 12, name: '12' },
    { id: 13, name: '13' },
    { id: 14, name: '14' },
    { id: 15, name: '15' },
  ];

  React.useEffect(() => {
    const endpoint = type === 'VIDEO' ? 'lessons/all' : 'categories';
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/${endpoint}`)
      .then(res => res.json())
      .then(data => setList(data));

    fetch(`${process.env.REACT_APP_BASE_URL}/cms/translation-keys`)
      .then(res => res.json())
      .then(({data}) => {
        if (data && data.length) {
          setTranslations(data.map((item) => item.raw_name.toLocaleLowerCase()))
        }
      });
  }, [type]);

  const uniqueRawName = (value) => {
    if (translations.includes(value.toLocaleLowerCase())) {
      return 'Generic name must be unique'
    }

    if (rawNameRegex.test(value)) {
      return 'Generic name should not contain: \n`!@#$%^&*()+=\[\]{};\':"\\|,.<>\/?~'
    }

    return undefined
  }

  const rawNameValidator = [required(), uniqueRawName]

  return (
    <Create title="Add Banner" {...props}>
      <SimpleForm>
        <BooleanInput label="Ativo" source="active" defaultValue />
        <TextInput label="Nome genérico" source="name" validate={rawNameValidator} />

        <TextInput label="Título (pt-BR)" source="ptbr-name" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Título (en-US)" source="enus-name" validate={required()} formClassName={classes.inline} />
        <TextInput label="Título (es-ES)" source="es-name" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Título (hu-HU)" source="hu-name" validate={required()} formClassName={classes.inline} /> */}
        <div></div>
        <TextInput label="Subtítulo (pt-BR)" source="ptbr-sub" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Subtítulo (en-US)" source="enus-sub" validate={required()} formClassName={classes.inline} />
        <TextInput label="Subtítulo (es-ES)" source="es-sub" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Subtítulo (hu-HU)" source="hu-sub" validate={required()} formClassName={classes.inline} /> */}
        <div></div>
        <TextInput label="Descrição (pt-BR)" source="ptbr-desc" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Descrição (en-US)" source="enus-desc" validate={required()} formClassName={classes.inline} />
        <TextInput label="Descrição (es-ES)" source="es-desc" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Descrição (hu-HU)" source="hu-desc" validate={required()} formClassName={classes.inline} /> */}

        <RadioButtonGroupInput
          source="type"
          label="Tipo"
          validate={required()}
          defaultValue={type}
          onChange={(value) => setType(value)}
          choices={[
            { id: 'VIDEO', name: 'Video' },
            { id: 'CATEGORY', name: 'Categoria' },
          ]}
        />
        <SelectInput source="target_id" label="Destino" choices={list} validate={required()} />
        <SelectInput source="priority" label="Prioridade" choices={priority} defaultValue={15} placeholder='Caso vazio, seu valor será atribuído como prioridade padrão' />
        <DateInput label="Data de ínicio" source="date-start" formClassName={clsx(classes.inline, 'first-child')} />
        <DateInput label="Date de término" source="date-end" formClassName={classes.inline} />
        <ImageInput label="Banner" source="image" validate={required()}>
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
}

export default BannerCreate;
